import {query} from '@di-nxt/query';
import {Task} from '../../../entities';
import {getDateString} from '../../../utils';
import {ScheduleDataModel} from '../types';

/**
 * Returns unassigned tasks for a given day based on the data for the current view model
 * @param date
 * @param viewmodel
 */
export const getDailyUnassignedTasks = (
  date: Date | string,
  viewmodel: ScheduleDataModel,
): Task[] => {
  const isoDate = getDateString(date);
  return query(viewmodel.unassignedTasks)
    .where(ut => ut.distrDate === isoDate)
    .orderBy(ut => ut.id)
    .toArray();
};
